import React from 'react';
import Umbrella from '../assets/images/icon-umbrella.svg';

export default () => {
  return <img src={Umbrella} alt="" />;
};
